import { render, staticRenderFns } from "./SalesCard.vue?vue&type=template&id=0ebf1554&scoped=true&lang=pug&"
import script from "./SalesCard.vue?vue&type=script&lang=js&"
export * from "./SalesCard.vue?vue&type=script&lang=js&"
import style0 from "./SalesCard.vue?vue&type=style&index=0&id=0ebf1554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf1554",
  null
  
)

export default component.exports